module.exports = __webpack_public_path__ + "static/media/cloud_infrastructure.290004fb.svg";